import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Image } from '@chatterbug/aaron'

import rightArrow from 'src/ui/assets/icons/right-arrow.svg'

const HeroCardReferenceSkeleton = ({
  disabled,
  titleSection,
  subtitleSection,
}) => {
  return (
    <Flex alignItems="center" justifyContent="space-between" py="2x">
      <Flex alignItems="center">
        <Box
          variant="text.h5"
          mr="1x"
          minWidth="auto"
          sx={{ whiteSpace: 'nowrap' }}
        >
          {titleSection}
        </Box>
        {subtitleSection && (
          <Box
            variant="text.paragraph"
            color="gray60"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {subtitleSection}
          </Box>
        )}
      </Flex>
      {!disabled && <Image src={rightArrow} width={24} height={24} />}
    </Flex>
  )
}

HeroCardReferenceSkeleton.propTypes = {
  disabled: PropTypes.bool,
  titleSection: PropTypes.any.isRequired,
  subtitleSection: PropTypes.any,
}

export default HeroCardReferenceSkeleton
